export default __webpack_public_path__ + "static/media/Footpad's Boots of Engulfing Twilight.b07722ec.jpg";